// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"hG","input":"hH","button":"hI"};